const events = [
  {
    name: 'Kickoff Ceremony',
    weekday: 'Mon',
    shortDate: 14,
    info: 'Mon 11/14 @ 4PM • ICSSC • DBH 4011',
    description: 'Come out to our opening ceremony to learn about the schedule, rules, and resources for WebJam! We will also be going over all of the exciting workshops we have planned for the week, so make sure to come by to learn more.'
  },
  {
    name: 'Intro to Vanilla JS',
    weekday: 'Tue',
    shortDate: 15,
    info: 'Tue 11/15 @ 7PM • Hack at UCI • DBH 3011',
    description: "Interested in learning about web development but don't know where to start? Join HackUCI at our workshop Tuesday, November 15 from 7-8PM to learn about basic web development in HTML, CSS, and JavaScript!"
  },
  {
    name: 'How to Create Tech for Social Good',
    weekday: 'Wed',
    shortDate: 16,
    info: 'Wed 11/16 @ 7PM • Commit the Change • DBH 3011',
    description: "Are you interested in creating tech for social good? Join Commit the Change as we discuss how to design and develop software to create an impact in your surrounding community, whether large or small! We'll be touching on development with regard to accessibility, inclusive technology, and ethics, as well as technical challenges and opportunities that arise when building tech for social good."
  },
  {
    name: 'Creating a More Accessible Web',
    weekday: 'Wed',
    shortDate: 16,
    info: 'Wed 11/16 @ 8PM • ICSSC Projects • DBH 3011',
    description: "Building a better web means ensuring people from all walks of life and abilities can participate. Learn why web accessibility is important and what it entails."
  },
  {
    name: 'A Deep Dive Into Backend Development Concepts',
    weekday: 'Thu',
    shortDate: 17,
    info: 'Thu 11/17 @ 7PM • DBH 3011',
    description: "Want to know more about server-side development? We'll walk you through how to set up a backend server from scratch, debug network traffic, and even a bit about deployment. (Workshop held by Sam and Eric from ACM)",
  },
  {
    name: 'Presentations & Closing Ceremony',
    weekday: 'Fri',
    shortDate: 18,
    info: 'Fri 11/18 @ 7PM • DBH 3011',
    description: 'WebJam comes to a close with our prize ceremony! Present your projects in front of our esteemed judges and audience for the chance to win some cool prizes.'
  }
];

export default events;
